module.exports = __webpack_public_path__ + "static/media/not-found.dc1d79df.png";